const Unauthorized = () => {
    return (
        <div
            style={{
                padding: '40px',
                paddingLeft: '310px', 
                minHeight: '100vh',
                backgroundColor: '#f7fbff',
            }}
        >
            <h2>🚫 Access Denied</h2>
            <p>You don’t have permission to view this page.</p>
        </div>
    );
};

export default Unauthorized;
